import React from "react";
import { ArrowLeft, Clock, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const ComingSoon = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }} className="min-h-screen flex items-center justify-center">
      <div className="container max-w-2xl mx-auto text-center px-4">
        {/* Back to Home */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 btn-secondary hover-scale"
          >
            <ArrowLeft size={16} />
            Back to Home
          </Link>
        </div>

        {/* Coming Soon Content */}
        <div className="voice-card" style={{ background: 'var(--bg-card)' }}>
          <div className="p-12">
            {/* Icon */}
            <div className="mb-6">
              <div 
                className="w-20 h-20 mx-auto rounded-full flex items-center justify-center"
                style={{ background: 'var(--accent-orange-200)' }}
              >
                <Clock size={40} style={{ color: 'var(--accent-orange-400)' }} />
              </div>
            </div>

            {/* Heading */}
            <h1 className="heading-hero mb-4">
              Coming Soon
            </h1>
            
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              We're working hard to bring you this feature. 
              Our AI agents are busy building something amazing!
            </p>

            {/* Features Preview */}
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="p-4 rounded-lg" style={{ background: 'var(--accent-blue-200)' }}>
                <h3 className="heading-3 mb-2">Advanced Features</h3>
                <p className="body-small">Enhanced AI capabilities and integrations</p>
              </div>
              <div className="p-4 rounded-lg" style={{ background: 'var(--accent-purple-200)' }}>
                <h3 className="heading-3 mb-2">Client Portal</h3>
                <p className="body-small">Dedicated dashboard and reporting</p>
              </div>
            </div>

            {/* Contact */}
            <div className="flex items-center justify-center gap-2 mb-6">
              <Mail size={20} style={{ color: 'var(--accent-orange-400)' }} />
              <span className="body-medium">
                Questions? Contact us at{" "}
                <a 
                  href="mailto:contact@aithatwows.com"
                  className="font-semibold"
                  style={{ color: 'var(--accent-orange-400)' }}
                >
                  contact@aithatwows.com
                </a>
              </span>
            </div>

            {/* CTA */}
            <Link to="/" className="btn-primary hover-scale">
              Get Started with AI Today
            </Link>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8">
          <p className="caption" style={{ color: 'var(--text-muted)' }}>
            Expected launch: Q2 2025 • Sign up today to get early access
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;